import { useMemo } from "react";
import { useSelector } from "react-redux";
import { AppState } from "store";
import { CommonEnums } from "models/enums";
import { MonthPickerQuickSelection } from "models/propTypes/datepickerPropTypes";
import { TranslationKeys } from "translations";
import { DateHelper, LocalizationHelperInstance } from "utils/helpers";

export const useSalaryMonthPickerSelections = (): MonthPickerQuickSelection[] => {
  const financialYears = useSelector((store: AppState) => store.auth.selectedCompany.financialYears);
  const today = DateHelper.today();

  const validFinancialYears = financialYears
    ?.filter((f) => new Date(f.start) < today)
    .sort((a, b) => new Date(a.start).getTime() - new Date(b.start).getTime());
  const firstFinancialYearStart = validFinancialYears?.[0]?.start ?? new Date(2020, 1, 1);

  const monthPickerSelections: MonthPickerQuickSelection[] = useMemo(
    () => [
      {
        key: CommonEnums.WintDeviationDateFilterTypes.CurrentMonth,
        text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.SalaryDeviation.CurrentMonth),
        range: {
          start: DateHelper.getFirstDayOfMonth(today),
          end: DateHelper.getLastDayOfMonth(today),
        },
      },
      {
        key: CommonEnums.WintDeviationDateFilterTypes.PreviousMonth,
        text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.SalaryDeviation.PreviousMonth),
        range: {
          start: DateHelper.getFirstDayOfPreviousMonth(today),
          end: DateHelper.getLastDayOfPreviousMonth(today),
        },
      },
      {
        key: CommonEnums.WintDeviationDateFilterTypes.CurrentVacationYear,
        text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.SalaryDeviation.CurrentVacationYear),
        range: {
          start: DateHelper.getFirstDayOfYear(today.getFullYear()),
          end: DateHelper.getLastDayOfYear(today.getFullYear()),
        },
      },
      {
        key: CommonEnums.WintDeviationDateFilterTypes.AllHistory,
        text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.SalaryDeviation.AllHistory),
        range: { start: new Date(firstFinancialYearStart), end: DateHelper.getLastDayOfMonth(today) },
      },
    ],
    [today]
  );

  return monthPickerSelections;
};
